import React from 'react';

import Menu from 'components/Menu';
import { Row } from 'react-table';
import { Invoice } from 'types';

import { getInvoiceActionEnabledMap } from './utils';

export type InvoiceMenuAction = 'View' | 'Edit' | 'Collect' | 'Refund' | 'Void' | 'Reopen' | 'Send' | '';

interface InvoiceActionsMenuProps {
  row: Row<Invoice>;
  disabled?: boolean;
  handleAction: (invoiceId: string, action: InvoiceMenuAction) => void;
}

const InvoiceActionsMenu = ({
  row,
  disabled = true,
  handleAction,
}: InvoiceActionsMenuProps): JSX.Element => {
  const getMenuItems = (invoice: Invoice): any => {
    const { editEnabled, collectEnabled, refundEnabled, voidEnabled, reopenEnabled, sendEnabled } =
      getInvoiceActionEnabledMap(invoice);

    const menuItems = [
      {
        title: 'View',
        onClick: () => handleAction(invoice.invoiceId, 'View'),
      },
    ];

    if (editEnabled) {
      menuItems.push({
        title: 'Edit',
        onClick: () => handleAction(invoice.invoiceId, 'Edit'),
      });
    }
    if (collectEnabled) {
      menuItems.push({
        title: 'Collect',
        onClick: () => handleAction(invoice.invoiceId, 'Collect'),
      });
    }
    if (refundEnabled) {
      menuItems.push({
        title: 'Refund',
        onClick: () => handleAction(invoice.invoiceId, 'Refund'),
      });
    }
    if (voidEnabled) {
      menuItems.push({
        title: 'Void',
        onClick: () => handleAction(invoice.invoiceId, 'Void'),
      });
    }
    if (reopenEnabled) {
      menuItems.push({
        title: 'Reopen',
        onClick: () => handleAction(invoice.invoiceId, 'Reopen'),
      });
    }
    if (sendEnabled) {
      menuItems.push({
        title: 'Send Receipt',
        onClick: () => handleAction(invoice.invoiceId, 'Send'),
      });
    }
    return menuItems;
  };

  return <Menu position='bottom-end' items={getMenuItems(row.original)} disabled={disabled} />;
};

export default InvoiceActionsMenu;
